import {combineReducers} from 'redux';
import LoadingReducer from './LoadingReducer';
import AuthReducer from './AuthReducer';
import HomeReducer from './HomeReducer';
import MessageReducer from './MessageReducer';
import ButtonReducer from './ButtonReducer';
import SettingsReducer from './SettingsReducer';
import DepartmentReducer from './DepartmentReducer';
import PostReducer from './PostReducer';
import AssetsReducer from './AssetsReducer';
import EmployeeReducer from './EmployeeReducer';
import ShiftReducer from './ShiftReducer';
import DutyRosterReducer from './DutyRosterReducer';
import AttendanceReducer from './AttendanceReducer';

const RootReducer = combineReducers({
     loadingReducer:LoadingReducer,
     authReducer:AuthReducer,
     homeReducer:HomeReducer,
     messageReducer:MessageReducer,
     buttonReducer:ButtonReducer,
     settingsReducer:SettingsReducer,
     departmentReducer: DepartmentReducer,
     postReducer: PostReducer,
     assetsReducer: AssetsReducer,
     employeeReducer: EmployeeReducer,
     shiftReducer: ShiftReducer,
     dutyRosterReducer: DutyRosterReducer,
     attendanceReducer: AttendanceReducer,
})

export default RootReducer;